import {Injectable} from '@angular/core';
import {RestApiService} from './rest-api.service';
import {env} from '../../core/utils/utils';
import {RuntimeEnvironment} from '../enums/runtime-environment.enum';
import {ApiRequestKey} from '../enums/api-request-key.enum';
import {ApiParamsService} from '../../core/services/api-params.service';

@Injectable({
  providedIn: 'root'
})
export class AztecScannerApiService {

  private readonly API_REQUEST_KEY: ApiRequestKey = ApiRequestKey.PREPARE_AZTEC_SESSION;

  get prepareAztecSessionEndpoint(): string {
    switch (env()) {
      case RuntimeEnvironment.DEV:
        return 'https://api-dev.kioskpolis.pl/oc-ac/utils/1.0.0/prepare/aztec/session';
      case RuntimeEnvironment.TEST:
        return 'https://api-test.kioskpolis.pl/oc-ac/utils/1.0.0/prepare/aztec/session';
      case RuntimeEnvironment.PROD:
        return 'https://api.kioskpolis.pl/oc-ac/utils/1.0.0/prepare/aztec/session';
      default:
        return 'https://api-test.kioskpolis.pl/oc-ac/utils/1.0.0/prepare/aztec/session';
    }
  }

  constructor(private api: RestApiService,
              private apiParamsService: ApiParamsService) { }

  public sendDecodedAztec(aztecCode: string): Promise<any> {
    const headers = {
      'Accept': 'application/json'
    };

    const body = this.createPayload(aztecCode);
    // this.metricsService.sendRequestMetric(<RequestMetricName>{
    //   ...this.metricName,
    //   type: RequestMetricResult.SEND
    // }, body);

    return this.api.post(this.prepareAztecSessionEndpoint,
        body, false, headers)
        .then((resp: any) => {
          // this.sendResponseMetrics(resp);
          return resp;
        })
        .catch((err: any) => {
          return Promise.reject(err);
          // this.metricsService.sendRequestMetric({
          //   ...this.metricName,
          //   type: RequestMetricResult.ERROR
          // }, err);
        });
  }

  private createPayload(aztecCode: string) {
    return {
      header: {
        processContext: {
          businessParameters: this.apiParamsService.createBusinessParams({
            requestKey: this.API_REQUEST_KEY
          })
        }
      },
      body: {
        aztecCode: aztecCode
      }
    };
  }
}
